












































import { Component, Mixins } from "vue-property-decorator";
import BaseServiceMixin from "../mixins/base.service.mixin";
import DateFilter from "@/components/DateFilter.vue";
import ReportService from "../services/report.service";
import { CompanyReportModel } from "../models/CompanyReportModel";
import { ApexOptions } from "apexcharts";
import moment from "moment-timezone";
import vueCustomScrollbar from "vue-custom-scrollbar";

@Component({
  components: {
    vueCustomScrollbar,
    DateFilter,
  },
})
export default class CompanyReport extends Mixins(BaseServiceMixin) {
  private reportService!: ReportService;
  private companyReportModel!: CompanyReportModel[];
  private chartType = "line";
  private acaOptions: ApexOptions = {
    chart: {
      id: "callacceptance",
      toolbar: {
        show: true,
        tools: {
          download: false,
          selection: false,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: false,
          reset: true,
        },
      },
    },
    xaxis: {
      type: "datetime",
      labels: {
        datetimeFormatter: {
          year: "yyyy",
          month: "MMM 'yy",
          day: "dd MMM",
          hour: "htt",
        },
      },
    },
    legend: {
      show: true,
    },
    noData: {
      text: "No data available for the chosen date range",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "Tomato",
        fontSize: "14px",
        fontFamily: undefined,
      },
    },
    tooltip: {
      x: {
        format: "dd MMM",
      },
    },
  };
  private acaSeries: ApexAxisChartSeries = [];
  public created() {
    this.reportService = new ReportService(this.axiosInstance);
  }

  private async handleDateSelectionChange(changedDates: Date[]) {
    //alert(`${changedDates[0]} - ${changedDates.length > 1 ? changedDates[1] : changedDates[0]}`);
    const summaryReport = changedDates.length > 1;
    const reports = summaryReport
      ? await this.getCompanyReport(changedDates[0], changedDates[1])
      : await this.getCompanyReport(changedDates[0], changedDates[0]);
    this.updateCharts(reports, summaryReport);
  }

  private async getCompanyReport(start: Date, end: Date): Promise<CompanyReportModel[]> {
    return await this.reportService.getCompanyReport(start, end);
  }

  private updateCharts(reports: CompanyReportModel[], summaryReport: boolean): void {
    this.acaSeries = [];
    const outdata = reports.map((w) => {
      return { x: moment.utc(w.startTime).tz("Europe/London"), y: w.averageAcceptanceTime.toFixed(1) };
    });
    this.acaSeries.push({ data: outdata, name: "AverageCallacceptanceTime" });
  }
}
